MS = window.MS || {};

(function($) {
  MS.productlanding_media_gallery = {
    selectors: {
      parent: '.ms-pl-media-gallery',
      parentSlideshowClass: 'ms-pl-media-gallery--slideshow',
      carousel: '.ms-pl-media-gallery__carousel',
      initClass: 'js-init-gallery-slick',
      carouselContainer: '.ms-pl-media-gallery__carousel-container',
      carouselItem: '.ms-pl-media-gallery__carousel-item',
      carouselItemPlayingClass: 'ms-pl-media-gallery__carousel-item--playing',
      videoTitle: '.ms-pl-media-gallery__carousel-item-title',
      titleList: '.ms-pl-media-gallery__title-list',
      titleListVisible: 'ms-pl-media-gallery__title-list--visible',
      listItem: '.ms-pl-media-gallery__list-item',
      listItemActive: 'ms-pl-media-gallery__list-item--active',
      listItemToggle: '.ms-pl-media-gallery__list-item-toggle',
      playButton: '.ms-pl-media-gallery__carousel-item-play',
      slideshow: '.ms-pl-media-gallery__slideshow',
      backToGrid: '.ms-pl-media-gallery__slideshow-switch',
      // Slideshow variables
      slideshowParent: '.ms-pl-media-gallery__slideshow',
      slideshowItems: '.ms-pl-media-gallery__slideshow-carousel-item',
      slideshowCarouselContainer:
        '.ms-pl-media-gallery__slideshow-carousel-container',
      slideshowPrev: '.ms-pl-media-gallery__slideshow-carousel-control--left',
      slideshowNext: '.ms-pl-media-gallery__slideshow-carousel-control--right',
      slideshowPlay: '.ms-pl-media-gallery__slideshow-video-play',
      mobileVideos: '.ms-pl-media-gallery__video',
      slideshowVideos: '.ms-pl-media-gallery__slideshow-video',
      slideshowVideoWrapper: '.ms-pl-media-gallery__slideshow-video-wrapper',
      // Carousel Variations
      singleMode: 'ms-pl-media-gallery__carousel--single',
      twoUpMode: 'ms-pl-media-gallery__carousel--2up',
      multiMode: 'ms-pl-media-gallery__carousel--flex',
      // Slideshow Variations
      slideshowMultiMode: 'ms-pl-media-gallery__slideshow--flex',
      // Video Controls
      videoControls: '.ms-pl-media-gallery__video-controls',
      controlPlayButton: '.ms-pl-media-gallery__control-play',
      controlPlayButtonPause:
        '.ms-pl-media-gallery__control-play > span.icon-pause',
      controlPlayButtonPlay:
        '.ms-pl-media-gallery__control-play > span.icon-play-sharp',
      trackSeeker: '.ms-pl-media-gallery__control-seeker > input',
      volumeButtonClass: 'ms-pl-media-gallery__control-volume',
      volumeLevel: '.ms-pl-media-gallery__control-volume > input',
      controlTime: '.ms-pl-media-gallery__control-time',
      controlTimeCurrent: '.ms-pl-media-gallery__control-time > .current',
      controlTimeDuration: '.ms-pl-media-gallery__control-time > .duration',
      controlFullScreen: '.ms-pl-media-gallery__control-fullscreen',
      // Slideshow Video Controls
      slideshowVideoControls: '.ms-pl-media-gallery__slideshow-video-controls',
      slideshowControlPlayButton:
        '.ms-pl-media-gallery__slideshow-control-play',
      slideshowControlPlayButtonPause:
        '.ms-pl-media-gallery__slideshow-control-play > span.icon-pause',
      slideshowControlPlayButtonPlay:
        '.ms-pl-media-gallery__slideshow-control-play > span.icon-play-sharp',
      slideshowTrackSeeker:
        '.ms-pl-media-gallery__slideshow-control-seeker > input',
      slideshowVolumeButtonClass:
        'ms-pl-media-gallery__slideshow-control-volume',
      slideshowVolumeLevel:
        '.ms-pl-media-gallery__slideshow-control-volume > input',
      slideshowControlTime: '.ms-pl-media-gallery__slideshow-control-time',
      slideshowControlTimeCurrent:
        '.ms-pl-media-gallery__slideshow-control-time > .current',
      slideshowControlTimeDuration:
        '.ms-pl-media-gallery__slideshow-control-time > .duration',
      slideshowControlFullScreen:
        '.ms-pl-media-gallery__slideshow-control-fullscreen',
      single: 'ms-single',
      twoUp: 'ms-twoup',
      multiple: 'ms-multiple'
    },
    breakpoints: {
      mobile: '400',
      tablet: '760',
      desktop: '1200'
    },
    PLAYER_VARS: {
      autoplay: 0,
      autohide: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      controls: 1,
      loop: 0,
      disablekb: 1,
      enablejsapi: 1,
      iv_load_policy: 3,
      playsinline: 0,
      fs: 1,
      color: 'white'
    },
    fromFS: false,
    player: null,
    init: function() {
      var _self = this;

      // If one item, --single,
      // If 2up, --2up,
      // if more than 2, --flex
      if ($(_self.selectors.carouselItem).length === 1) {
        $(_self.selectors.carousel).addClass(_self.selectors.singleMode);
        $(_self.selectors.parent).addClass(_self.selectors.single);
      } else if ($(_self.selectors.carouselItem).length <= 2) {
        $(_self.selectors.carousel).addClass(_self.selectors.twoUpMode);
        $(_self.selectors.parent).addClass(_self.selectors.twoUp);
      } else if ($(_self.selectors.carouselItem).length > 2) {
        $(_self.selectors.carousel).addClass(_self.selectors.multiMode);
        $(_self.selectors.slideshowParent).addClass(
          _self.selectors.slideshowMultiMode
        );
        $(_self.selectors.parent).addClass(_self.selectors.multiple);
      }

      this.initSlider();
      this.resizeListener();
      this.fullscreenChange();
    },
    initSlider: function() {
      var _self = this;
      var settings = {
        focusOnSelect: false,
        arrows: false,
        dots: false,
        infinite: false,
        variableWidth: true
      };

      if ($(window).width() < 760) {
        // CALL WHEN MOBILE
        if ($(_self.selectors.carousel).hasClass(_self.selectors.singleMode)) {
          _self.slideshowToggle();
          return;
        }

        $(_self.selectors.carousel).addClass(_self.selectors.initClass);
        $(_self.selectors.carouselContainer)
          .not('.slick-initialized')
          .slick(settings);

        if ($(_self.selectors.carouselItem).length >= 2) {
          $(_self.selectors.titleList).addClass(
            _self.selectors.titleListVisible
          );
        } else {
          $(_self.selectors.titleList).removeClass(
            _self.selectors.titleListVisible
          );
        }

        // Call events -- ONLY WHEN INITIALIZED
        _self.initSliderEvents();
      } else {
        // CALL WHEN TABLET - DESKTOP
        $(_self.selectors.carousel).removeClass(_self.selectors.initClass);
        $(_self.selectors.titleList).removeClass(
          _self.selectors.titleListVisible
        );

        if (
          $(_self.selectors.carouselContainer).hasClass('slick-initialized')
        ) {
          $(_self.selectors.carouselContainer).slick('unslick');
        }

        if ($(_self.selectors.carousel).hasClass(_self.selectors.singleMode)) {
          _self.videoControls();
        }
      }

      // Call toggle event handler
      _self.slideshowToggle();
    },
    setupPlayer: function(el) {
      var _that = MS.productlanding_media_gallery;
      var isMobile = $(window).width() < _that.breakpoints.tablet;

      el = _that.checkPlayerElement(el);

      if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        window.onYouTubeIframeAPIReady = function() {
          _that.player = new YT.Player(el[0], {
            playerVars: isMobile
              ? $.extend({}, _that.PLAYER_VARS, { controls: 1 })
              : _that.PLAYER_VARS,
            videoId: $(el).data('videoId'),
            events: {
              onReady: _that.playerReady.bind(this)
            }
          });
        };
      } else {
        _that.player = new YT.Player(el[0], {
          playerVars: isMobile
            ? $.extend({}, _that.PLAYER_VARS, { controls: 1 })
            : _that.PLAYER_VARS,
          videoId: $(el).data('videoId'),
          events: {
            onReady: _that.playerReady.bind(this),
            onStateChange: _that.playerStateChange.bind(this)
          }
        });
      }
    },
    resizeListener: function() {
      var _self = this;

      $(window).on('resize', function(e) {
        // Close slideshow when in mobile
        if (
          $(window).width() < _self.breakpoints.tablet &&
          $(_self.selectors.slideshowParent + ':visible').length
        ) {
          // Make sure to destroy any existing and playing videos
          _self.destroyPlayer();
          $(_self.selectors.slideshowParent).hide();
          $(_self.selectors.carousel).show();
        }

        if (
          $(window).width() >= _self.breakpoints.tablet &&
          $('.' + _self.selectors.initClass).length <= 0
        ) {
          // If the player is already buffered, playing, stopped or paused, don't destroy it.
          if (_self.player && _self.player.getPlayerState() !== -1) {
            return;
          }

          _self.destroyPlayer();

          // Remove any existing playing classes
          $(_self.selectors.carouselItem).each(function(i, v) {
            if ($(v).hasClass(_self.selectors.carouselItemPlayingClass)) {
              $(v).removeClass(_self.selectors.carouselItemPlayingClass);
            }
          });
        }

        _self.initSlider();
      });
    },
    initSliderEvents: function() {
      var _self = this;

      if ($(window).width() < 760) {
        $(_self.selectors.carouselContainer).on('beforeChange', function(
          event,
          slick,
          currentSlide,
          nextSlide
        ) {
          $(
            $(_self.selectors.titleList + ' > ' + _self.selectors.listItem)[
              nextSlide
            ]
          )
            .addClass(_self.selectors.listItemActive)
            .siblings()
            .removeClass(_self.selectors.listItemActive);

          // Bring back the button and the poster image
          if (nextSlide !== currentSlide) {
            _self.destroyPlayer();

            $($(_self.selectors.carouselItem)[currentSlide]).removeClass(
              _self.selectors.carouselItemPlayingClass
            );

            // Remove --paused as well
            $($(_self.selectors.carouselItem)[currentSlide]).removeClass(
              _self.selectors.carouselItem.substring(1) + '--paused'
            );
          }
        });

        // Title List Click Toggle
        $(_self.selectors.titleList).on('click', _self.listItemToggle, function(
          e
        ) {
          // go to selected slide
          $(_self.selectors.carouselContainer).slick(
            'slickGoTo',
            parseInt($(e.target).data('index'))
          );

          var activeSlide = $(_self.selectors.carouselItem)[
            $(_self.selectors.carouselContainer).slick('slickCurrentSlide')
          ];

          // Autoplay only from here
          // For auto start
          _self.setupPlayer($(activeSlide).find(_self.selectors.mobileVideos));
        });
      }

      /**
       * ==========================================
       *
       * Call slideShowToggle to add event listener
       * to the Play icon
       *
       * ==========================================
       */
      _self.slideshowToggle();
    },
    slideshowToggle: function() {
      var _self = this;
      // Play button on click
      $(_self.selectors.parent).on(
        'click',
        _self.selectors.carouselItem,
        function(e) {
          var _that = MS.productlanding_media_gallery;
          // If Single Mode is on
          if (
            $(window).width() < _that.breakpoints.tablet ||
            $(_that.selectors.carousel).hasClass(_that.selectors.singleMode)
          ) {
            // Slider is not active. Do nothing.
            if (
              !$(_that.selectors.carousel).hasClass(
                _that.selectors.singleMode
              ) &&
              !$(this).hasClass('slick-active')
            ) {
              return;
            }

            var targetDiv = $(e.target)
              .next('div')
              .find(_that.selectors.mobileVideos).length
              ? $(e.target)
                  .next('div')
                  .find(_that.selectors.mobileVideos)
              : $(e.target).find(_that.selectors.mobileVideos);

            // disable click on the body if playing
            if (
              $(e.target)
                .closest(_self.selectors.carouselItem)
                .hasClass(_self.selectors.carouselItemPlayingClass)
            ) {
              return;
            }

            if (_that.player && typeof _that.player.getPlayerState === "function" && _that.player.getPlayerState() === -1) {
              // Add Playing Class
              $(_that.player.getIframe())
                .closest(_that.selectors.carouselItem)
                .addClass(_that.selectors.carouselItemPlayingClass);

              _that.player.playVideo();
            } else if (
              _that.player &&
              typeof _that.player.getPlayerState === "function" &&
              (_that.player.getPlayerState() === YT.PlayerState.PAUSED ||
                _that.player.getPlayerState() === YT.PlayerState.ENDED)
            ) {
              $(e.target)
                .closest(_that.selectors.carouselItem)
                .removeClass(
                  _that.selectors.carouselItem.substring(1) + '--paused'
                );

              _that.playVideo(targetDiv);
              // _that.player.playVideo();
            } else {
              _that.setupPlayer(targetDiv);
            }
          }
          //  If Two-Up OR Multi mode
          else if (
            $(_that.selectors.carousel).hasClass(_that.selectors.twoUpMode) ||
            $(_that.selectors.carousel).hasClass(_that.selectors.multiMode)
          ) {
            var videoIndex = $(e.target)
              .next('div')
              .find(_that.selectors.playButton).length
              ? $(e.target)
                  .next('div')
                  .find(_that.selectors.playButton)
                  .data('index')
              : $(e.target)
                  .find(_that.selectors.playButton)
                  .data('index');

            var slideshowSettings = {
              infinite: $(_that.selectors.slideshowItems).length > 2,
              prevArrow: $(_that.selectors.slideshowPrev),
              nextArrow: $(_that.selectors.slideshowNext),
              variableWidth: true,
              focusOnSelect: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: videoIndex,
              centerMode: $(_that.selectors.slideshowItems).length > 2,
              centerPadding:
                $(_that.selectors.slideshowItems).length > 2 ? 0 : null,
              draggable: false,
              swipe: false,
              touchMove: false
            };

            $(_that.selectors.parent).addClass(
              _that.selectors.parentSlideshowClass
            );

            // full span container on load
            if ($(_that.selectors.slideshowItems).length > 2) {
              $(_that.selectors.slideshowCarouselContainer).css(
                'width',
                '100%'
              );
            }

            // Activate Slideshow
            $(_that.selectors.slideshowCarouselContainer)
              .not('.slick-initialized')
              .slick(slideshowSettings);

            // Refresh slideshow on load
            setTimeout(function() {
              $(_that.selectors.slideshowCarouselContainer).slick('refresh');
            }, 500);

            // Fadeout grid, Fade in slideshow
            $(_that.selectors.carousel).fadeOut(800, 'swing', function() {
              $(_that.selectors.slideshow).fadeIn(800);
            });

            // Call Slideshow Events
            _that.initSlideshowEvents();

            // Player div
            var playerDiv = $(
              _that.selectors.slideshowItems + '.slick-active'
            ).find(_that.selectors.slideshowVideos);

            // Setup player
            _that.setupPlayer(playerDiv);
          }
        }
      );

      // Add listener to "Back to Grid Button"
      $(_self.selectors.parent).on(
        'click',
        _self.selectors.backToGrid,
        function(e) {
          var _that = MS.productlanding_media_gallery;

          if ($(window).width() < 760) return;
          $(_that.selectors.parent).removeClass(
            _that.selectors.parentSlideshowClass
          );

          // Fadeout slideshow, Fade in grid
          $(_that.selectors.slideshow).fadeOut(800, 'swing', function() {
            $(_that.selectors.carousel).fadeIn(800);

            // Deactivate Slideshow
            $(_that.selectors.slideshowCarouselContainer).slick('unslick');

            _that.destroyPlayer();

            // Clear ended video wrappers
            $(_that.selectors.slideshowCarouselContainer)
              .find(_that.selectors.slideshowVideoWrapper + '--ended')
              .removeClass(
                _that.selectors.slideshowVideoWrapper.substring(1) + '--ended'
              );
          });
        }
      );
    },
    initSlideshowEvents: function() {
      var _self = this;
      var $slideshow = $(_self.selectors.slideshowCarouselContainer);
      var _that = MS.productlanding_media_gallery;

      var slideshowSeekerStylesheet = document.createElement('style');
      slideshowSeekerStylesheet.setAttribute('id', 'slideshowStyles');
      var slideshowVolumeStylesheet = document.createElement('style');
      slideshowVolumeStylesheet.setAttribute('id', 'slideshowVolumeStyles');

      var $slideshowTrackSeekerInput = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowTrackSeeker
      );
      var $slideshowVolumeInput = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowVolumeLevel
      );
      var $slideshowVolumeButton = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          '.' +
          _self.selectors.slideshowVolumeButtonClass
      );
      var $slideshowControlPlayback = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowControlPlayButton
      );
      var $slideshowControlPlay = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowControlPlayButtonPlay
      );
      var $slideshowControlPause = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowControlPlayButtonPause
      );
      var $slideshowControlFullScreen = $(
        _self.selectors.slideshowItems +
          '.slick-active ' +
          _self.selectors.slideshowControlFullScreen
      );

      // Add custom stylesheet
      document.body.appendChild(slideshowSeekerStylesheet);
      document.body.appendChild(slideshowVolumeStylesheet);

      $slideshow.on('beforeChange', function(
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        // Execute these events only when the slide actually moved
        // We can't use 'afterChange' instead since we need the previous slide's value
        // and 'afterChange' doesn't provide it
        if (currentSlide !== nextSlide) {
          // Reset all their seekers

          $($(_that.selectors.slideshowItems)[currentSlide])
            .children('div')
            .children(_that.selectors.slideshowVideoControls)
            .children('.ms-pl-media-gallery__slideshow-control-seeker')
            .children('input')
            .val(0);

          $($(_that.selectors.slideshowItems)[currentSlide])
            .children('div')
            .children(_that.selectors.slideshowVideoControls)
            .children('.ms-pl-media-gallery__slideshow-control-volume')
            .children('input')
            .val(100);

          // Remove styles of slideshow sliders
          $('#slideshowStyles').empty();
          $('#slideshowVolumeStyles').empty();

          _that.destroyPlayer();

          removeDOMListeners();
          addDOMListeners();
        }
      });

      // Update slick-active
      $slideshow.on('afterChange', function(event, slick, currentSlide) {
        // Slideshow Video Controls Override
        $slideshowTrackSeekerInput = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowTrackSeeker
        );
        $slideshowVolumeInput = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowVolumeLevel
        );
        $slideshowVolumeButton = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            '.' +
            _self.selectors.slideshowVolumeButtonClass
        );
        $slideshowControlPlayback = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowControlPlayButton
        );
        $slideshowControlPlay = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowControlPlayButtonPlay
        );
        $slideshowControlPause = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowControlPlayButtonPause
        );
        $slideshowControlFullScreen = $(
          _self.selectors.slideshowItems +
            '.slick-active ' +
            _self.selectors.slideshowControlFullScreen
        );

        if (!_that.player) {
          var targetDiv = $(
            _self.selectors.slideshowItems + '.slick-active '
          ).find(_that.selectors.slideshowVideos);

          // Setup Player
          _that.setupPlayer(targetDiv);
        }

        removeDOMListeners();
        addDOMListeners();
      });

      var removeDOMListeners = function() {
        $slideshowControlPlayback.off('click');
        $slideshowVolumeButton.off('click');
        $slideshowTrackSeekerInput.off('mouseup touchend change');
        $slideshowVolumeInput.off('input change');
        $slideshowControlFullScreen.off('click');
      };

      var addDOMListeners = function() {
        // Re-init events
        $slideshowControlPlayback.on('click', function(e) {
          var _that = MS.productlanding_media_gallery;
          // _that.player.pauseVideo();
          if (_that.player.getPlayerState() === YT.PlayerState.PLAYING) {
            _that.player.pauseVideo();
            // $slideshowControlPause.fadeOut('fast');
            // $slideshowControlPlay.fadeIn('fast');
          } else if (_that.player.getPlayerState() === YT.PlayerState.PAUSED) {
            _that.player.playVideo();
            // $slideshowControlPause.fadeIn('fast');
            // $slideshowControlPlay.fadeOut('fast');
          }
        });

        $slideshowVolumeButton.on('click', function(e) {
          $(e.target).toggleClass(
            _self.selectors.slideshowVolumeButtonClass + '--open'
          );
        });

        // For actual seeker click
        $slideshowTrackSeekerInput.on('mouseup touchend', function(e) {
          var _that = MS.productlanding_media_gallery;
          slideshowSeekerStylesheet.textContent = _that.setupSeekerStyles(
            e.target,
            _that.selectors.slideshowTrackSeeker
          );

          var newTime = _that.player.getDuration() * (e.target.value / 100);
          _that.player.seekTo(newTime);
        });

        // For emulated change via time update
        $slideshowTrackSeekerInput.on('change', function(e) {
          var _that = MS.productlanding_media_gallery;
          slideshowSeekerStylesheet.textContent = _that.setupSeekerStyles(
            e.target,
            _that.selectors.slideshowTrackSeeker
          );
        });

        $slideshowVolumeInput.on('input change', function(e) {
          var _that = MS.productlanding_media_gallery;
          slideshowVolumeStylesheet.textContent = _that.setupSeekerStyles(
            e.target,
            _that.selectors.slideshowVolumeLevel
          );

          // Set Volume
          _that.player.setVolume($(e.target).val());
        });

        $slideshowControlFullScreen.on('click', function(e) {
          var _that = MS.productlanding_media_gallery;
          // var $slideshowItem = $(e.target).closest(
          //   _that.selectors.slideshowItems
          // );

          var iframe = _that.player.getIframe();

          var requestFullScreen =
            iframe.requestFullScreen ||
            iframe.mozRequestFullScreen ||
            iframe.webkitRequestFullScreen;
          if (requestFullScreen) {
            if (document.fullscreenElement) {
              document.exitFullscreen();
              // console.log(_that.player.getCurrentTime(), 'from button click');
              // $slideshowItem.removeClass(
              //   _that.selectors.slideshowItems.substring(1) + '--fullscreen'
              // );
            } else {
              requestFullScreen.bind(iframe)();
              // _that.player.playVideo();
              // $slideshowItem.addClass(
              //   _that.selectors.slideshowItems.substring(1) + '--fullscreen'
              // );
            }
          }
        });

        // Slideshow Yellow Play Button on Ended or Paused
        $(_self.selectors.slideshowItems + '.slick-active ').on(
          'click',
          _self.selectors.slideshowVideoWrapper + '--ended',
          function(e) {
            $(e.target).removeClass(
              _self.selectors.slideshowVideoWrapper.substring(1) + '--ended'
            );
            _self.playVideo(_self.player.getIframe(), true);
          }
        );

        $(_self.selectors.slideshowItems + '.slick-active ').on(
          'click',
          _self.selectors.slideshowVideoWrapper + '--paused',
          function(e) {
            $(e.target).removeClass(
              _self.selectors.slideshowVideoWrapper.substring(1) + '--paused'
            );
            _self.playVideo(_self.player.getIframe(), true);
          }
        );
      };
    },
    playerStateChange: function(e) {
      var _that = MS.productlanding_media_gallery;
      var $slideshowPlay = $(_that.selectors.slideshowPlay);
      var notPlaying =
        e.data === YT.PlayerState.ENDED || e.data === YT.PlayerState.PAUSED;
      var targetIframe = e.target.getIframe();

      // If Buffering, show custom play button
      // -1 = unstarted
      if (e.data === YT.PlayerState.BUFFERING || e.data === -1) {
        if (
          $(targetIframe).closest(_that.selectors.slideshowVideoWrapper).length
        ) {
          $(targetIframe)
            .closest(_that.selectors.slideshowVideoWrapper)
            .addClass(
              _that.selectors.slideshowVideoWrapper.substring(1) + '--paused'
            );
        } else if (
          $(targetIframe).closest(_that.selectors.carouselItem).length
        ) {
          $(targetIframe)
            .closest(_that.selectors.carouselItem)
            .removeClass(_that.selectors.carouselItemPlayingClass);
          $(targetIframe)
            .closest(_that.selectors.carouselItem)
            .addClass(_that.selectors.carouselItem.substring(1) + '--paused');
        }
      }

      if (
        notPlaying &&
        $(targetIframe).closest(_that.selectors.slideshowVideoWrapper).length
      ) {
        if (e.data === YT.PlayerState.ENDED) {
          $(targetIframe)
            .closest(_that.selectors.slideshowVideoWrapper)
            .addClass(
              _that.selectors.slideshowVideoWrapper.substring(1) + '--ended'
            );
        } else if (e.data === YT.PlayerState.PAUSED) {
          $(targetIframe)
            .closest(_that.selectors.slideshowVideoWrapper)
            .addClass(
              _that.selectors.slideshowVideoWrapper.substring(1) + '--paused'
            );
        }

        // Re-enable swipe/drag onPlay
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'draggable',
          true
        );
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'swipe',
          true
        );
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'touchMove',
          true
        );
      } else if (
        notPlaying &&
        $(targetIframe).closest(_that.selectors.carouselItem).length
      ) {
        if (e.data === YT.PlayerState.PAUSED) {
          $(targetIframe)
            .closest(_that.selectors.carouselItem)
            .removeClass(_that.selectors.carouselItemPlayingClass);
          $(targetIframe)
            .closest(_that.selectors.carouselItem)
            .addClass(_that.selectors.carouselItem.substring(1) + '--paused');
        }
        if (e.data === YT.PlayerState.ENDED) {
          $(targetIframe)
            .closest(_that.selectors.carouselItem)
            .removeClass(_that.selectors.carouselItemPlayingClass);
          _that.destroyPlayer();
        }
      }

      // youtube on seek returns a series of state change
      if (
        !notPlaying &&
        $(targetIframe).closest(_that.selectors.slideshowVideoWrapper).length
      ) {
        $(targetIframe)
          .closest(_that.selectors.slideshowVideoWrapper)
          .removeClass(
            _that.selectors.slideshowVideoWrapper.substring(1) + '--paused'
          );
      } else if (
        !notPlaying &&
        $(targetIframe).closest(_that.selectors.carouselItem).length
      ) {
        $(targetIframe)
          .closest(_that.selectors.carouselItem)
          .addClass(_that.selectors.carouselItemPlayingClass);
        $(targetIframe)
          .closest(_that.selectors.carouselItem)
          .removeClass(_that.selectors.carouselItem.substring(1) + '--paused');
      }

      if (
        $(_that.selectors.slideshowCarouselContainer + ':visible').length &&
        !notPlaying
      ) {
        // Disable swipe/drag onPlay
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'draggable',
          false
        );
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'swipe',
          false
        );
        $(_that.selectors.slideshowCarouselContainer).slick(
          'slickSetOption',
          'touchMove',
          false
        );
      }
    },
    destroyPlayer: function() {
      var _that = MS.productlanding_media_gallery;

      if (_that.player && typeof _that.player.getPlayerState === 'function') {
        if (_that.player.getPlayerState() === YT.Player.PLAYING) {
          _that.player.stopVideo();
        }
        _that.player.destroy();
      }

      _that.player = null;
    },
    playerReady: function(e) {
      var _that = MS.productlanding_media_gallery;
      var targetIframe = e.target.getIframe();

      if (_that.player && typeof _that.player.mute === 'function') {
        _that.player.mute();

        _that.playVideo(
          targetIframe,
          $(targetIframe).hasClass(_that.selectors.slideshowVideos.substring(1))
        );
      } else {
        setTimeout(function() {
          _that.playerReady(e);
        }, 500);
      }
    },
    playVideo: function(targetIframe, fromSlideshow) {
      var _self = this;
      var _that = MS.productlanding_media_gallery;

      if (
        !_that.player ||
        (_that.player && typeof _that.player.playVideo !== 'function')
      ) {
        this.playVideo();
        return;
      }

      if (fromSlideshow) {
        // Play Video
        // var playVideoLoop = setInterval(function() {
        //   if (_that.player) {
        //     _that.player.playVideo();
        //     clearInterval(playVideoLoop);
        //   }
        // }, 500);

        setTimeout(function() {
          _that.player.playVideo();
        }, 500);

        // Call Time Update Function
        // _that.onTimeUpdate(targetIframe, fromSlideshow);

        // Setup time
        $(targetIframe)
          .next('div')
          .children(_self.selectors.slideshowControlTime)
          .children(_self.selectors.slideshowControlTimeDuration)
          .html(_self.formatTime(_that.player.getDuration()));

        // Hide controls after 5 seconds
        setTimeout(function() {
          $(targetIframe)
            .next('div')
            .addClass(
              _that.selectors.slideshowVideoControls.substring(1) + '--hidden'
            );
        }, 5000);
      } else {
        // Add Playing Class
        $(targetIframe)
          .closest(_self.selectors.carouselItem)
          .toggleClass(_self.selectors.carouselItemPlayingClass);
        // Play Video
        setTimeout(function() {
          _that.player.playVideo();
        }, 500);
        if ($(window).width() >= 760) {
          // Call Time Update Function
          // _that.onTimeUpdate(targetIframe, fromSlideshow);

          // Setup time
          $(targetIframe)
            .next('div')
            .children(_self.selectors.controlTime)
            .children(_self.selectors.controlTimeDuration)
            .html(_self.formatTime(_that.player.getDuration()));
          // Hide controls after 5 seconds
          setTimeout(function() {
            $(targetIframe)
              .next('div')
              .children('div')
              .addClass(
                _that.selectors.videoControls.substring(1) + '--hidden'
              );
          }, 5000);
        }
      }
    },
    videoControls: function() {
      var _self = this;
      var seekerStylesheet = document.createElement('style');
      var volumeStylesheet = document.createElement('style');
      var $trackSeekerInput = $(_self.selectors.trackSeeker);
      var $volumeInput = $(_self.selectors.volumeLevel);
      var $volumeButton = $('.' + _self.selectors.volumeButtonClass);
      var $controlPlayback = $(_self.selectors.controlPlayButton);
      var $controlPlay = $(_self.selectors.controlPlayButtonPlay);
      var $controlPause = $(_self.selectors.controlPlayButtonPause);
      var $controlFullScreen = $(_self.selectors.controlFullScreen);

      // Add Custom Stylesheets
      document.body.appendChild(seekerStylesheet);
      document.body.appendChild(volumeStylesheet);

      $controlPlayback.on('click', function(e) {
        var _that = MS.productlanding_media_gallery;

        if (_that.player.getPlayerState() === YT.PlayerState.PLAYING) {
          _that.player.pauseVideo();
          $(_that.player.getIframe())
            .closest(_that.selectors.carouselItem)
            .addClass(_that.selectors.carouselItem.substring(1) + '--paused');
          // $controlPause.fadeOut('fast');
          // $controlPlay.fadeIn('fast');
        } else if (_that.player.getPlayerState() === YT.PlayerState.PAUSED) {
          _that.player.playVideo();
          // $controlPause.fadeIn('fast');
          // $controlPlay.fadeOut('fast');
        }
      });

      $volumeButton.on('click', function(e) {
        $(e.target).toggleClass(_self.selectors.volumeButtonClass + '--open');
      });

      // For actual seeker click
      $trackSeekerInput.on('mouseup touchend', function(e) {
        var _that = MS.productlanding_media_gallery;
        seekerStylesheet.textContent = _that.setupSeekerStyles(
          e.target,
          _that.selectors.trackSeeker
        );

        var newTime = _that.player.getDuration() * (e.target.value / 100);
        _that.player.seekTo(newTime);
      });

      // For emulated change via time update
      $trackSeekerInput.on('change', function(e) {
        var _that = MS.productlanding_media_gallery;
        seekerStylesheet.textContent = _that.setupSeekerStyles(
          e.target,
          _that.selectors.trackSeeker
        );
      });

      $volumeInput.on('input change', function(e) {
        var _that = MS.productlanding_media_gallery;
        volumeStylesheet.textContent = _that.setupSeekerStyles(
          e.target,
          _that.selectors.volumeLevel
        );
        // Set Volume
        _that.player.setVolume($(e.target).val());
      });

      $controlFullScreen.on('click', function(e) {
        var _that = MS.productlanding_media_gallery;
        var iframe = $(e.target)
          .parents(_that.selectors.videoControls)
          .siblings('iframe')[0];

        var requestFullScreen =
          iframe.requestFullScreen ||
          iframe.mozRequestFullScreen ||
          iframe.webkitRequestFullScreen;
        if (requestFullScreen) {
          requestFullScreen.bind(iframe)();
          _that.player.playVideo();
        }
      });

      // detect enter or exit fullscreen mode
      document.addEventListener(
        'webkitfullscreenchange',
        _self.fullscreenChange
      );
      document.addEventListener('mozfullscreenchange', _self.fullscreenChange);
      document.addEventListener('fullscreenchange', _self.fullscreenChange);
      document.addEventListener('MSFullscreenChange', _self.fullscreenChange);
    },
    fullscreenChange: function(e) {
      var _that = MS.productlanding_media_gallery;

      // $(document).on(
      //   'webkitfullscreenchange mozfullscreenchange fullscreenchange',
      //   function(e) {
      //     if (document.fullscreenElement) {
      //       console.log('fullscreen enter');
      //     } else if (document.exitFullscreen) {
      //       var savedTime = _that.player.getCurrentTime();

      //       if ($(_that.selectors.slideshowParent + ':visible').length) {
      //         // Remove residual fullscreen class
      //         // $(e.target)
      //         //   .closest(_that.selectors.slideshowItems)
      //         //   .removeClass(
      //         //     _that.selectors.slideshowItems.substring(1) + '--fullscreen'
      //         //   );
      //         // Refresh slideshow on load
      //         setTimeout(function() {
      //           $(_that.selectors.slideshowCarouselContainer).slick('refresh');
      //           _that.fromFS = true;
      //         }, 1000);
      //       }

      //       // var playVideoLoop = setInterval(function() {
      //       //   if (_that.player) {
      //       //     _that.player.playVideo();
      //       //     _that.player.seekTo(savedTime);
      //       //     clearInterval(playVideoLoop);
      //       //   }
      //       // }, 500);
      //     }
      //   }
      // );
    },
    setupSeekerStyles: function(el, selector) {
      var _self = this;
      var prefs = [
        'webkit-slider-runnable-track',
        'moz-range-track',
        'ms-track'
      ];
      var curValue = el.value;
      // var val = (curValue - 1) * 24.66666667;
      var style = '';
      var yellow = '#facd00';
      var background = 'rgba(255, 255, 255, 0.28)';
      var style = '';

      // Setup browser-specific styles
      for (var i = 0; i < prefs.length; i++) {
        style +=
          selector +
          ' {background: linear-gradient(to right, ' +
          yellow +
          ' 0%, ' +
          yellow +
          ' ' +
          curValue +
          '%, ' +
          background +
          ' ' +
          curValue +
          '%, ' +
          background +
          ' 100%) !important}';
        style +=
          selector +
          ' input::-' +
          prefs[i] +
          '{background: linear-gradient(to right, ' +
          yellow +
          ' 0%, ' +
          yellow +
          ' ' +
          curValue +
          '%, ' +
          background +
          ' ' +
          curValue +
          '%, ' +
          background +
          ' 100%) !important}';
      }

      return style;
    },
    formatTime: function(time) {
      var _self = this;
      var minutes = Math.floor(time / 60);
      var seconds = time - minutes * 60;
      seconds = ~~seconds;

      return (
        minutes + ':' + ((seconds + '').length >= 2 ? seconds : '0' + seconds)
      );
    },
    onTimeUpdate: function(targetIframe, fromSlideshow) {
      var _self = this;
      var _that = MS.productlanding_media_gallery;

      var $currentTime;
      var $trackSeeker;

      var slickInstance;

      var thisSlideIndex;
      var $slideshowVideoWrapper;

      // if from slideshow
      if (fromSlideshow) {
        $slideshowVideoWrapper = $(targetIframe).closest(
          _that.selectors.slideshowVideoWrapper
        );
        slickInstance = $(_that.selectors.slideshowCarouselContainer).slick(
          'getSlick'
        );

        thisSlideIndex = $(targetIframe)
          .closest('.slick-slide')
          .data('slick-index');
        $currentTime = $(targetIframe)
          .next('div')
          .children(_that.selectors.slideshowControlTime)
          .children(_that.selectors.slideshowControlTimeCurrent);
        $trackSeeker = $(targetIframe)
          .next('div')
          .children('div.ms-pl-media-gallery__slideshow-control-seeker')
          .children('input');
      } else {
        $currentTime = $(targetIframe)
          .next('div')
          .children(_that.selectors.controlTime)
          .children(_that.selectors.controlTimeCurrent);
        $trackSeeker = $(targetIframe)
          .next('div')
          .children('div.ms-pl-media-gallery__control-seeker')
          .children('input');
      }

      var interval = setInterval(function() {
        // Skip this if it's mobile
        if ($(window).width() < _that.breakpoints.tablet || !_that.player) {
          clearInterval(interval);
          return;
        }

        if (fromSlideshow) {
          if (slickInstance.currentSlide === thisSlideIndex) {
            $currentTime.html(_that.formatTime(_that.player.getCurrentTime()));
            $trackSeeker.val(
              (_that.player.getCurrentTime() / _that.player.getDuration()) * 100
            );

            $trackSeeker.change();
          } else {
            clearInterval(interval);
          }
        } else {
          $currentTime.html(_that.formatTime(_that.player.getCurrentTime()));
          $trackSeeker.val(
            (_that.player.getCurrentTime() / _that.player.getDuration()) * 100
          );
          $trackSeeker.change();
        }
      }, 1000);
    },
    checkPlayerElement: function(targetDiv) {
      // Element is still an IFRAME with youtube contents. Destroy it.
      if (targetDiv[0].tagName !== 'div') {
        var attributes = targetDiv.prop('attributes');
        var $before = targetDiv.prev();
        targetDiv.replaceWith('<div></div>');
        targetDiv = $before.next();
        $.each(attributes, function() {
          targetDiv.attr(this.name, this.value);
        });
      }
      return targetDiv;
    }
  };
})(jQuery);
